import GlossaryDetailedScreenShader from "../../shaders/glossaryScreen/GlossaryDetailedScreenShader";
import GlossaryDetailedTermDefinition from "./GlossaryDetailedTermDefinition";
import GlossaryDetailedTermExample from "./GlossaryDetailedTermExample";
import {get_nested} from "../../../services/JsonHandler";
import GlossaryExamplePicture from "../../images/glossaryScreen/GlossaryExamplePicture";

export default function GlossaryDetailedScreenDefinition({term}) {
    // Used in GlossaryDetailedScreenContent to display Term definition

    // PROPERTIES
    const termPictureUrl = get_nested(['termExamplePicture', 'filePath'], term, null)
    const termPictureRatio = get_nested(['termExamplePicture', 'ratio'], term, null)

    // BUILD
    return (
        <div className="bg-backgroundLight3 overflow-auto h-full relative px-[16px] pb-[16px] mt-[4px]">
            <GlossaryDetailedScreenShader />
            <GlossaryDetailedTermDefinition definition={term.definition} />
            <GlossaryDetailedTermExample example={term.example} />
            <GlossaryExamplePicture pictureUrl={termPictureUrl}
                                    pictureRatio={termPictureRatio} />
        </div>
    );
}